import { Question } from '@dreryk/egabinet-survey-frontend-api';

import { createTranslatedText } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';
import { PreInterviewFormController } from '../PreInterviewForm.types';

const QUESTION_ANSWER_MAX_LENGTH = 500;

type QuestionAnswerTextareaProps = Pick<PreInterviewFormController, 'register'> & {
   readonly question: Question;
};

export const QuestionAnswerTextarea = (props: QuestionAnswerTextareaProps): JSX.Element => {
   return (
      <Textarea
         controller={props.register(props.question.id.toString())}
         testId={`questionAnswer-${props.question.id}`}
         label={createTranslatedText(`${props.question.questionNumber}. ${props.question.content}`)}
         placeholder={appointmentsTranslationKeys.preInterview.modal.shared.form.questionAnswer.placeholder}
         maxRows={6}
         rows={6}
         defaultValue={null}
         maxLength={QUESTION_ANSWER_MAX_LENGTH}
      />
   );
};
